import { render, staticRenderFns } from "./FiltrosDescarte.vue?vue&type=template&id=016c7148&"
import script from "./FiltrosDescarte.vue?vue&type=script&lang=js&"
export * from "./FiltrosDescarte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports